module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-text.f66ed62f.svg";